import Cookies from 'js-cookie'

const TokenKey = 'token'
// 获取token值
export function getToken() {
  return Cookies.get(TokenKey)
}
var PATTERN_IP = /^\d+(\.\d+)?$/;
var domain = process.env.VUE_APP_BASE_API_domain;
console.log(domain);
export function setToken(token) {
  console.log(window.location.host)
  if (window.location.host == "localhost:9527") {
    return Cookies.set(TokenKey, token);
  }
  if (PATTERN_IP.test(domain)) {// ip
    return Cookies.set(TokenKey, token);
  } else {// 域名
    return Cookies.set(TokenKey, token, { domain: domain });
  }
}
// 删除token值
export function removeToken() {
  if (window.location.host == "localhost:9527") {
    return Cookies.remove(TokenKey);
  }
  if (PATTERN_IP.test(domain)) {// ip
    return Cookies.remove(TokenKey);
  } else {// 域名
    Cookies.remove(TokenKey, { domain: domain });
  }
}
const Account_type = 'account_type'
// 获取account_type值
export function getaccount_type() {
  return Cookies.get(Account_type)
}

export function setaccount_type(account_type) {
  return Cookies.set(Account_type, account_type)
}
// 删除account_type值
export function removeaccount_type() {
  return Cookies.remove(Account_type)
}
// 获取name值
const Name = 'name'
export function getname() {
  return Cookies.get(Name)
}
export function setname(name) {
  return Cookies.set(Name, name)
}
// 删除account_type值
export function removename() {
  return Cookies.remove(Name)
}
